export enum ChannelMemberUserTypeEnum {
  TENANT_USER = 'TENANT_USER',
  COMPANY_USER = 'COMPANY_USER',
}
